import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HormoneCourse from "@/components/hormone/HormoneCourse";
import { Toaster } from "@/components/ui/toaster";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HormoneCourse />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
